import { trigger, state, style, transition, animate } from '@angular/animations';
import { AfterViewInit, Component, HostListener, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

// Services
import { ViewportService } from '../../../../../core/_services/viewport/viewport.service';

// Components
import { ButtonComponent } from '../../../../../shared/_components/button/button.component';
import { EmbeddedBillingWebViewComponent } from '../embedded-billing-web-view/embedded-billing-web-view.component';

// Models
import { ButtonShape, ButtonVariant } from '../../../../../shared/_model/button.model';

// Directives
import { StateHandlerDirective } from '../../../../../core/_components/state-handler/state-handler.component';

@Component({
  selector: 'pp-setup-billing',
  templateUrl: './setup-billing.component.html',
  animations: [
    trigger('heightAnimation', [
      state('collapsed', style({ height: '0px' })),
      state('expanded', style({ height: '{{height}}px' }), { params: { height: 200 } }),
      transition('collapsed <=> expanded', animate('1s ease-in-out')),
    ]),
  ],
  imports: [ButtonComponent, EmbeddedBillingWebViewComponent],
})
export class SetupBillingComponent extends StateHandlerDirective implements AfterViewInit {

  // Aliases
  buttonShape = ButtonShape;
  buttonVariant = ButtonVariant;

  // iFrame handlers
  stripPricingTableHeight = 0;

  // Services
  readonly activeModal = inject(NgbActiveModal);
  private readonly viewportService = inject(ViewportService);

  ngAfterViewInit(): void {
    // Set session window height
    this.onWindowResize();
  }

  /**
   * On window resize event. Sets the frame height of the payment selection element.
   * @private
   * @memberof SetupBillingComponent
   */
  @HostListener('window:resize')
  onWindowResize(): void {
    const stripePricingTable = document.querySelector('stripe-pricing-table') as HTMLElement;
    if (!stripePricingTable) return;

    // Retain this code for when more subscriptions become available
    // this.viewportService.isViewportLg$.subscribe({
    //   next: (response: boolean) => {
    //     this.stripPricingTableHeight = response ? window.innerHeight - 224 : 360;
    //     this.cdr.detectChanges();
    //   },
    // });

    this.stripPricingTableHeight = 360;
    this.cdr.detectChanges();
  }
}
